import { forwardRef, RefObject, useState } from "react";  //M10-11637
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Button } from "src/components";
import { invoiceActions } from "src/context/invoice-slice";
import { RootState } from "src/context/store";
import FilterAccordion from "src/features/fields/container/FilterAccordion";
import { DateRange, DayPicker } from "react-day-picker";
import { toast } from "src/hooks/useToast";
import { MODULE_NAME_LIST, ORDER_MODE_LIST, ORDER_TYPE_LIST, UPLOAD_TYPE_LIST } from "src/pages/invoice-master/invoice-helper"; //M10-13117 //M10-14101

interface FilterItem {
  id?: string;
  name?: string;
  code?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // Add an index signature
}

interface InvoiceFiltersProps {
  onClose: () => void;
  companyDetails: FilterItem[];
  divisionDetails: FilterItem[];
  stockistDetails: FilterItem[];
  statusDetails: FilterItem[];
  assigneeDetails: FilterItem[];
  cityDetails: FilterItem[];
  districtDetails: FilterItem[];
  stateDetails: FilterItem[];
  rejectionDetails?: FilterItem[];
  ref: RefObject<HTMLElement>;
}

const Divider = () => <div className="w-full h-[0.0625rem] my-2 bg-[#0000001a]" />;

const InvoiceFiltersComponent = forwardRef<HTMLElement, InvoiceFiltersProps>(
  ({ onClose, companyDetails, divisionDetails, statusDetails, assigneeDetails, cityDetails, districtDetails, stateDetails, rejectionDetails }, ref) => {
    //M10-11637
    const filters = useSelector((state: RootState) => state?.invoice?.InvoiceFilters);

    const [localDateType, setLocalDateType] = useState(filters.dateType || []);
    const [tempFilters, setTempFilters] = useState({
      dateRange: filters.dateRange || { from: undefined, to: undefined },
      fromTime: "00:00",
      toTime: "23:59",
    });
    //M10-11637
    const SORT_OPTIONS = [
      { key: "ASC", value: "Ascending" },
      { key: "DESC", value: "Descending" },
    ];
    //textract filter
     const TEXTRACT_OPTIONS = [
      { key: "MV-AI", value: "MV Lens" },
      { key: "Regular", value: "Regular" },
    ];

    const dateType = [
      { key: "file_upload_date", value: "File Upload Date" },
      { key: "ordered_date", value: "Order Placed Date" },
      { key: "rejected_at", value: "Rejected Initiated At" }
    ]
    // const { InvoiceFilters } = useSelector((state: RootState) => state.invoice);
    const dispatch = useDispatch();

    const companyFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "company", value: details }));
    };

    const divisionFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "division", value: details }));
    };

    const statusFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "status", value: details }));
    };

    const assigneeFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "assignee", value: details }));
    };

    const cityFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "city", value: details }));
    };

    const districtFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "district", value: details }));
    };

    const stateFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "state", value: details }));
    };

    const rejectionFilterHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "rejection", value: details }));
    };

    // Build a readable label ("HEADER - REMARK") for each rejection category.
    const rejectionOptions = (rejectionDetails || []).map((item) => ({
      ...item,
      display_label: [item.rejection_header, item.rejection_remark].filter(Boolean).join(" - ") || item.rejection_code,
    }));

    const sortFilerHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "sorting", value: details }));
    };
    //textract filter
    const textractFilerHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "textract", value: details }));
    };
    //M10-13117
    const moduleTypeFilerHandler = (details: FilterItem[]) => {
      console.log("details",details)
      dispatch(invoiceActions.setInvoiceFilters({ key: "moduleType", value: details }));
    };
    const uploadTypeFilerHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "uploadType", value: details }));
    };
    //M10-13117
    //M10-14101
    const orderModeFilerHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "orderMode", value: details }));
    };
    const orderTypeFilerHandler = (details: FilterItem[]) => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "orderType", value: details }));
    };
    //M10-14101

    const dateTypeHandler = (details: FilterItem[]) => {
      setLocalDateType([details]);  //M10-11637
    };

    const resetFilter = () => {
      dispatch(invoiceActions.setInvoiceFilters({ key: "company", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "division", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "stockist", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "status", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "assignee", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "city", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "district", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "state", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "rejection", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "fuidNo", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "sorting", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "textract", value: [] })); //textract filter
      dispatch(invoiceActions.setInvoiceFilters({ key: "dateRange", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "dateType", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "fromTime", value: [] })); //M10-11637
      dispatch(invoiceActions.setInvoiceFilters({ key: "toTime", value: [] })); //M10-11637
      //M10-13117
      dispatch(invoiceActions.setInvoiceFilters({ key: "moduleType", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "uploadType", value: [] }));
      //M10-13117
      //M10-14101
      dispatch(invoiceActions.setInvoiceFilters({ key: "orderMode", value: [] }));
      dispatch(invoiceActions.setInvoiceFilters({ key: "orderType", value: [] }));
      //M10-14101
      dispatch(invoiceActions.setIsResetFilter(false));
    };

    //M10-11637
    const dateRangeHandler = () => {
      if (localDateType?.length === 0) {
        toast({
          description: "Please choose a date type first",
          variant: "destructive",
        })
        return;
      }
      const { dateRange, fromTime, toTime } = tempFilters;

      // Merge times into date range
      if (dateRange?.from) {
        let from = new Date(dateRange.from);
        let to = dateRange?.to ? new Date(dateRange.to) : null;

        if (from && fromTime) {
          const [h, m] = fromTime.split(":");
          from.setHours(Number(h), Number(m), 0, 0);
        }

        if (to && toTime) {
          const [h, m] = toTime.split(":");
          to.setHours(Number(h), Number(m), 0, 0);
        }
        const payload: DateRange = {
          from: from.toISOString() as any,
          ...(to && { to: to.toISOString() as any })
        };

        // Dispatch to Redux
        dispatch(invoiceActions.setInvoiceFilters({ key: "dateType", value: localDateType }));
        dispatch(invoiceActions.setInvoiceFilters({ key: "dateRange", value: payload }));
        dispatch(invoiceActions.setInvoiceFilters({ key: "fromTime", value: fromTime }));
        dispatch(invoiceActions.setInvoiceFilters({ key: "toTime", value: toTime }));
      }
    };
    //M10-11637

    return (
      <aside ref={ref} className="bg-white border-l-[1px] min-w-[24rem] overflow-y-auto max-w-[25rem] border-l-[#00000014] fixed px-8 text-[#49484C] text-xl font-semibold py-5 right-0  h-screen">
        <div className="flex items-center justify-between gap-5 mt-3">
          <h3 className="whitespace-nowrap">Fetch filters</h3>
          <Button className="border py-1 bg-[#7F56D9] text-white" onClick={resetFilter}>
            Reset
          </Button>
          <Button className="border py-2 bg-[#7F56D9] text-white" onClick={onClose}>
            Close
          </Button>
        </div>

        {/* filters  */}
        <div className="flex flex-col pt-4">
          {/* textract filter M10-13117*/}
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={moduleTypeFilerHandler}
            title="Module Type" //change name
            arrayToFilter={MODULE_NAME_LIST}
            defaultValue={filters.moduleType}
            isSingleSelect={true}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={uploadTypeFilerHandler}
            title="Upload Type" //change name
            arrayToFilter={UPLOAD_TYPE_LIST}
            defaultValue={filters.uploadType}
            isSingleSelect={true}
          />
          <Divider />
          {/* M10-13117 */}
          {/* M10-14101 */}
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={orderModeFilerHandler}
            title="Order Mode"
            arrayToFilter={ORDER_MODE_LIST}
            defaultValue={filters.orderMode}
            isSingleSelect={true}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={orderTypeFilerHandler}
            title="Order Type"
            arrayToFilter={ORDER_TYPE_LIST}
            defaultValue={filters.orderType}
            isSingleSelect={true}
          />
          <Divider />
          {/* M10-14101 */}
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={textractFilerHandler}
            title="MV Lens" //change name
            arrayToFilter={TEXTRACT_OPTIONS}
            defaultValue={filters.textract}
            isSingleSelect={true}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="key"
            displayKey="value"
            onSelectingFilter={sortFilerHandler}
            title="Sort By"
            arrayToFilter={SORT_OPTIONS}
            defaultValue={filters.sorting}
            isSingleSelect={true}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="invoice_assignment_id"
            displayKey="user_name"
            onSelectingFilter={assigneeFilterHandler}
            title="Assignee"
            arrayToFilter={assigneeDetails}
            defaultValue={filters.assignee}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="code"
            displayKey="shortname"
            onSelectingFilter={companyFilterHandler}
            title="Company Name"
            arrayToFilter={companyDetails}
            defaultValue={filters.company}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="company_divisioncode"
            displayKey="division_name"
            onSelectingFilter={divisionFilterHandler}
            title="Division"
            arrayToFilter={divisionDetails}
            defaultValue={filters.division}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="fuid_status_id"
            displayKey="fuid_status_desc"
            title="Status"
            arrayToFilter={statusDetails}
            onSelectingFilter={statusFilterHandler}
            defaultValue={filters.status}
          />
          <>
            <Divider />
            <FilterAccordion
              displayKey="city_name"
              title="City"
              arrayToFilter={cityDetails}
              uniqueKey="city_code"
              onSelectingFilter={cityFilterHandler}
              defaultValue={filters.city}
            />
          </>
          <>
            <Divider />
            <FilterAccordion
              displayKey="district_name"
              title="District"
              arrayToFilter={districtDetails}
              uniqueKey="district_code"
              onSelectingFilter={districtFilterHandler}
              defaultValue={filters.district}
            />
          </>
          <>
            <Divider />
            <FilterAccordion
              displayKey="state_name"
              title="State"
              arrayToFilter={stateDetails}
              uniqueKey="state_code"
              onSelectingFilter={stateFilterHandler}
              defaultValue={filters.state}
            />
          </>
          {rejectionOptions.length > 0 && (
            <>
              <Divider />
              <FilterAccordion
                displayKey="display_label"
                title="Rejection"
                arrayToFilter={rejectionOptions}
                uniqueKey="rejection_code"
                onSelectingFilter={rejectionFilterHandler}
                defaultValue={filters.rejection}
              />
            </>
          )}
          <>
            <Divider />
            <FilterAccordion displayKey="" title="Date & Time" arrayToFilter={[]} uniqueKey="" onSelectingFilter={() => { }} defaultValue={[]} />
          </>
          <div className="my-0">
            <div className="flex items-center gap-2 mb-2">
              <Autocomplete
                placeholder="Date Type" //M10-11637
                suggestionList={dateType}
                displayKey="value"
                uniqueKey="key"
                onSelectionChange={dateTypeHandler}
                defaultValue={filters.dateType?.[0]}
              />
              {/* M10-11637 */}
              <Button
                className="bg-[#7F56D9] text-white w-[10rem]"
                onClick={() => {
                  dispatch(invoiceActions.setInvoiceFilters({ key: "dateRange", value: [] }));
                  dispatch(invoiceActions.setInvoiceFilters({ key: "dateType", value: [] }));
                  dispatch(invoiceActions.setInvoiceFilters({ key: "fromTime", value: "00:00" }));
                  dispatch(invoiceActions.setInvoiceFilters({ key: "toTime", value: "23:59" }));
                  setTempFilters({ dateRange: { from: undefined, to: undefined }, fromTime: "00:00", toTime: "23:59" })
                  setLocalDateType([])
                }}>Clear</Button>
            </div>
            <div className="flex flex-col gap-3">
              <DayPicker
                classNames={{
                  today: `border border-[#8051FF]`,
                  selected: `bg-[#ded9ff] border-[#8051FF] font-semibold`, // Highlight the selected day
                  root: `border border-[#D0D0D0] rounded-xl p-5 flex items-center justify-center text-[1rem]`, // Add a shadow to the root element
                  day: `p-2 cursor-pointer`, // Base styles for each day
                  chevron: `fill-[#7F56D9] hover:fill-[#8051FF] transition-colors`, // Change the color of the chevron
                  outside: `text-gray-400`,
                }}
                mode="range"
                defaultMonth={filters.dateRange?.from}
                selected={tempFilters.dateRange}
                onSelect={(range: any) => setTempFilters({ ...tempFilters, dateRange: range })}
                numberOfMonths={1}
              />

              {tempFilters.dateRange?.from &&
                <div className="flex items-center gap-4 text-sm">

                  <div className="flex flex-col">
                    <label className="text-gray-600 mb-1">From Time</label>
                    <input
                      type="time"
                      value={tempFilters.fromTime}
                      onChange={(e) => setTempFilters({ ...tempFilters, fromTime: e.target.value })}
                      className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#8051FF]"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-gray-600 mb-1">To Time</label>
                    <input
                      type="time"
                      value={tempFilters.toTime}
                      onChange={(e) => setTempFilters({ ...tempFilters, toTime: e.target.value })}
                      className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#8051FF]"
                    />
                  </div>

                  <Button
                    className="bg-[#7F56D9] text-white w-[10rem] mt-5"
                    onClick={() => dateRangeHandler()}
                  >
                    Apply
                  </Button>
                </div>
              }

            </div>
            {/* M10-11637 */}
          </div>
        </div>
      </aside>
    );
  }
);

export default InvoiceFiltersComponent;
